import BlockIcon          from "@/assets/icons/BlockIcon";
import { EmptyState }     from "@/components/ui/empty-state"
import { useTranslation } from "react-i18next"

const NotFoundPage = () => {
    const { t } = useTranslation();

    return (
        <EmptyState 
            icon={<BlockIcon size="2xl" />}
            title={t('app.empty.title')}
            description={t('app.empty.description')}
            height="calc(100% - 72px)"
            justifyContent="center"
            alignContent="center"
        />    
    )
}

export default NotFoundPage